/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserContext } from '@irian-ro/auth-shared-module';

export const noAuthGuard: CanActivateFn = (route) => {
  const userContext = inject(UserContext);
  const router = inject(Router);
  const logout = route.data[0].logout;

  if (!userContext.isLoggedIn() || logout) {
    return true;
  }

  return router.parseUrl('/');
};
